'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Inside DI/Sparky application the dynamic imports are using
 *
 * To solve issues with bundle size we declare here HostApp enums as constants
 * and don't use - import { HostApp } from "@reporting-n-viz/reporting-app";
 *
 * The source from "@reporting-n-viz/reporting-app"
 *      export declare enum HostApp {
 *          Fawkes = "Fawkes",
 *          DI = "DI"
 *      }
 * */
const HOST_APP_FAWKES = "Fawkes";
const HOST_APP_DI = "DI";

exports.HOST_APP_DI = HOST_APP_DI;
exports.HOST_APP_FAWKES = HOST_APP_FAWKES;
